module.exports = __webpack_public_path__ + "static/media/typescript.d5104695.svg";